import { ICollectionMapper } from '../Firestore/ICollectionMapper'
import { IMasterCatalog, MasterCatalog } from './MasterCatalog'
import { PriceListEntryMapper } from '../PriceList/PriceListEntry/PriceListEntryMapper'

export class MasterCatalogMapper implements ICollectionMapper<MasterCatalog> {
  map(data: IMasterCatalog): MasterCatalog {
    const masterCatalog = new MasterCatalog(data.companyId)
    masterCatalog.id = data.id

    masterCatalog.entries = data.entries.map(( new PriceListEntryMapper ).map)

    return masterCatalog
  }

  serialize(object: MasterCatalog): IMasterCatalog {
    return JSON.parse(JSON.stringify(object))
  }
}
